// @flow

import styled from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";

export const RaceDataList = styled.div`
  display: flex;
  list-style-type: none;
  ${({ isIconShown }) => isIconShown && "padding-right: 12px;"}

  > li {
    color: ${(props) => props.textColor};
  }
`;

export const RaceDataListDescription = styled.ul`
  display: flex;
  flex-wrap: wrap;
`;

export const RaceDataListItem = styled.li`
  font-size: 14px;
  display: flex;
  align-items: center;
  position: relative;
  text-transform: capitalize;
  color: ${buildColor("grey", "D4")};
  line-height: 125%;

  && {
    color: ${(props) => props.changed && buildColor("orange", "500")};
  }

  &:not(:last-child) {
    &::after {
      content: "|";
      color: ${buildColor("grey", "L2")};
      margin: 0 8px;
      font-size: 16px;
    }
  }
`;

export const ChangesIcon = styled.span`
  padding-right: 2px;
  display: inherit;
`;

export const HorseIcon = styled.span`
  margin-right: 8px;
  display: flex;
  height: 100%;
`;
